import {APIError} from 'data/errors';
import {makeGetHome} from 'main/factories/usecases';
import {PlanTypeEnum} from 'presentation/constants';
import {sortBookedByDate} from 'presentation/utils';
import {getCurrentAccountAdapter} from 'main/adapters/current-account-adapter';

import {GetHomeParams, ParsedAppointment} from './types';
import {parseExamAppointments} from '../../utils/parseExamAppointments';
import {parseHealthAppointments} from '../../utils/parseHealthAppointments';
import {parseOdontoAppointments} from '../../utils/parseOdontoAppointments';
import {parseTelehealthAppointments} from '../../utils/parseTelehealthAppointments';
import {parseSurgeryAppointments} from '../../utils/parseSurgeryAppointments';

export const getHome = async ({signal, useV3 = false}: GetHomeParams) => {
	const {
		beneficiary: {tipoPlanoC: planType},
	} = getCurrentAccountAdapter();

	const response = await makeGetHome(useV3).get({signal});

	if (response instanceof APIError) {
		throw response;
	}
	const isOdonto = planType === PlanTypeEnum.ODONTO;
	const isHealth = planType === PlanTypeEnum.HEALTH;

	const parsedExamAppointments = !isOdonto
		? parseExamAppointments(response.agendamentosExames)
		: [];
	const parsedOdontoAppointments = !isHealth
		? parseOdontoAppointments(response.agendamentosOdonto)
		: [];
	const parsedHealthAppointments = !isOdonto
		? parseHealthAppointments(response.agendamentosSaude)
		: [];
	const parsedTelehealthAppointments = !isOdonto
		? parseTelehealthAppointments(response.agendamentosTeleconsulta)
		: [];
	const parsedSurgeryAppointments =
		!isOdonto
			? parseSurgeryAppointments(response.agendamentosCirurgicos ?? [])
			: [];

	const appointmentsForSorting: ParsedAppointment[] = [
		...parsedHealthAppointments,
		...parsedExamAppointments,
		...parsedOdontoAppointments,
		...parsedTelehealthAppointments,
		...parsedSurgeryAppointments,
	];

	const sortedAppointmentsByDateAndHour = sortBookedByDate({
		list: appointmentsForSorting,
		order: 'desc',
	});

	const myReferrals = response.flMeusEncaminhamentos;

	return {
		...response,
		agendamentosExames: !isOdonto ? response.agendamentosExames : [],
		agendamentosOdonto: !isHealth ? response.agendamentosOdonto : [],
		agendamentosSaude: !isOdonto ? response.agendamentosSaude : [],
		agendamentosTeleconsulta: !isOdonto ? response.agendamentosTeleconsulta : [],
		appointments: sortedAppointmentsByDateAndHour,
		myReferrals,
	};
};
